export default __webpack_public_path__ + "static/media/whyBrokerVTGMIcon5.8c3fa7c7.webp";